export const KEY_FEATURED_SESSIONS = 'featured-sessions'
export const KEY_REQUIRE_REGISTRATION_ACCOUNT_APPROVAL = 'require-registration-account-approval'
export const KEY_SESSION_AUDIT_TAGS = 'session-audit-tags'
export const KEY_FEATURED_CERTIFIED_TUTORS = 'featured-certified-tutors'
export const KEY_PUBLIC_COUNT_TUTORS = 'public-count-tutors'
export const KEY_PUBLIC_COUNT_SESSIONS = 'public-count-sessions'
export const KEY_PUBLIC_COUNT_LEARNERS = 'public-count-learners'
export const KEY_PUBLIC_COUNT_MEMBERS = 'public-count-members'
export const KEY_PUBLIC_COUNT_SAT_BOOTCAMP_LEARNERS = 'public-count-sat-bootcamp-learners'
export const KEY_PUBLIC_COUNT_SAT_BOOTCAMP_TUTORS = 'public-count-sat-bootcamp-tutors'
export const KEY_USER_ADMIN_MESSAGE_TEMPLATES = 'user-admin-message-templates'
export const KEY_KEY_CLUB_TUTORATHON_2023_LEADERBOARDS = 'key-club-tutorathon-2023-leaderboards'
export const KEY_INELIGIBLE_PSAT_CWIDS = 'ineligible_psat_cwids'
export const KEY_DIGEST_EMAIL_DETAILS = 'digest-email-details'
export const KEY_MARKETING_SOURCES = 'marketing-sources'
export const KEY_ZOOM_TEMPORARY_HOSTS = 'zoom-temporary-hosts'
